import { css } from 'styled-components';
import { BaseLinkProps } from 'types';
import { marginDecorator, paddingDecorator } from 'utils';

export const regular = ({ background, ...rest }: BaseLinkProps) => css`
	all: unset;
	color: ${background};
	cursor: pointer;
	text-decoration: underline;
	text-decoration-color: ${background};
	${marginDecorator(rest)}
	${paddingDecorator(rest)}
`;
